import styled from "styled-components";

import { smMedia } from "../../../utils/getMediaStyle";

import { HeaderText } from "./Text";

export default styled(HeaderText)`
  font-size: ${({ size }) => (size ? size : "16")}px;
  color: ${({ color, theme }) =>
    color ? theme.color[color].main : theme.color.text.primary};
  ${({ smSize }) => smMedia(`font-size:${smSize}px; line-height:28px`)}
`;
